import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useDimension, useIsInfographic } from '~map-preview/states/infographic'
import { hideAllTools, showAllTools } from '~map-preview/states/ui'
import { resetStyle, setStyle } from '~map-preview/states/viewState'

const useHandleInfographic = () => {
  const { width, height } = useDimension()
  const isInfographic = useIsInfographic()
  const dispatch = useDispatch()

  useEffect(() => {
    if (isInfographic) {
      dispatch(hideAllTools())
      dispatch(
        setStyle({
          width: width,
          height: height,
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          margin: 'auto',
          left: '360px'
        })
      )
    } else {
      dispatch(showAllTools())
      dispatch(resetStyle())
    }
  }, [isInfographic, width, height, dispatch])
}

export { useHandleInfographic }
